import React, { useState, useEffect } from "react";
import "./AboutUsSec2.css";
import { useLocation } from "react-router-dom";
const servicesData = {
  MICE: {
    title: "MICE Solutions",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/mice%20(1).webp",
    points: [
      {
        title: "Ease of Access:",
        desc: "With world-class airports, smooth visa processes, and excellent transport links, reaching and moving around our destinations is always convenient for your clients.",
      },
      {
        title: "Seamless Transport & Logistics:",
        desc: "From luxury transfers to large-scale event coordination, we handle every logistical detail to ensure smooth, reliable operations for conferences, incentives, and exhibitions managed by our partner  agents..",
      },
      {
        title: "Destination Expertise for Events:",
        desc: " Our extensive knowledge of destinations like Qatar, Singapore, Malaysia, and India allows agents to confidently plan and execute successful MICE programs.",
      },
      {
        title: "Sports & Event-Ready Destinations:",
        desc: "Access destinations equipped with world-class stadiums and event  spaces, ideal for group travel, sports events, and incentive programs  managed by your agency.",
      },
    ],
  },

  Events: {
    title: "Events",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/aboutus-service/event.webp",
    points: [
      {
        title: "Corporate & Social Events:",
        desc: "Comprehensive planning and execution for conferences, gala dinners, networking events, product launches, and celebrations.",
      },
      {
        title: "Venue Sourcing Expertise:",
        desc: " Access to a wide range of premium venues, meeting spaces, and event facilities tailored to client requirements.",
      },
      {
        title: "On-Ground Event Management:",
        desc: "Dedicated teams oversee logistics, guest coordination, and event operations to ensure flawless execution.",
      },
      {
        title: "Customized Event Experiences:",
        desc: " Tailor-made concepts, entertainment options, and branding opportunities create memorable experiences for every group.",
      },
       {
        title: "Supplier & Vendor Coordination:",
        desc: "Strong local partnerships help secure quality services, competitive pricing, and seamless event delivery.",
      },
    ],
  },

  "B2B Services": {
    title: "B2B Services",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/about-service2.webp",
    points: [
      {
        title: "Trusted Supplier Network:",
        desc: "Access a dependable network of local partners, hotels, and transport providers across destinations like Qatar, Singapore, Malaysia, India, and Africa.",
      },
      {
        title: "Competitive Agent Rates:",
        desc: "We offer market-friendly rates and curated packages designed exclusively for travel agents, helping you maintain a profitable margin while delivering premium experiences to your customers.",
      },
      {
        title: "Operational Efficiency:",
        desc: "From airport transfers to guided excursions and accommodation coordination, we handle end-to-end logistics so you can focus on client servicing.",
      },
      {
        title: "Business Expansion Support:",
        desc: "Leverage our regional expertise and long-standing relationships to explore new markets and design packages that resonate with your target audience. We assist agents in building stronger portfolios with reliable local insights.",
      },
      {
        title: "Exceptional Client Experiences:",
        desc: "Enhance your client offerings with our curated, high-quality travel programs. We help you deliver experiences your customers will remember, and return for.",
      },
    ],
  },
  "Luxury Travel": {
    title: "Luxury Travel",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/about-service3.webp",
    points: [
      {
        title: "Private Transfers:",
        desc: "Provide your clients with smooth, high-end transfers through our fleet of luxury vehicles, private jets, and VIP airport services—ensuring seamless comfort and style at every stage of travel.",
      },
      {
        title: "Luxurious Accommodations:",
        desc: "Access an exclusive selection of handpicked five-star hotels, private villas, and premium resorts that redefine sophistication and deliver exceptional guest experiences.",
      },
      {
        title: "Exclusive Experiences:",
        desc: "Enhance your offerings with rare, once-in-a-lifetime experiences such as private safaris, behind-the-scenes cultural tours, and elite access to world-class events.",
      },
      {
        title: "Elite Concierge Assistance:",
        desc: "Our 24/7 concierge support ensures that every client request - from private guides to last-minute reservations, is handled with precision and discretion.",
      },
      {
        title: "Tailored Luxury Activities:",
        desc: "Offer travelers unique adventures like private yacht cruises, desert expeditions, or scenic helicopter rides. Each one is crafted for comfort, exclusivity, and unmatched personalization.",
      },
    ],
  },

  "Group Travel": {
    title: "Group Travel",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/about-service5.webp",
    points: [
      {
        title: "Customized Group Itineraries:",
        desc: "Empower your clients with tailor-made travel plans designed for groups of all sizes. Be it leisure groups, incentive travelers, or special interest tours, we craft with precision and creativity.",
      },
      {
        title: "Multi-Destination Expertise:",
        desc: "Offer seamless cross-country or regional journeys with our strong local network and logistical support across Africa, Asia, and the Middle East.",
      },
      {
        title: "Agent-Assisted Group & Incentive Travel:",
        desc: "Support your clients’ group requirements through our curated destination knowledge, engaging experiences, and reliable on-ground arrangements.",
      },
      {
        title: "Streamlined Operations:",
        desc: "Rely on our expert coordination team to manage every detail. From accommodation blocks to transfers and guided tours, expect a hassle-free experience for you and your clients.",
      },
      {
        title: "Cultural & Adventure Tours:",
        desc: "Add depth to your packages with immersive cultural encounters, wildlife safaris, and adventure-based group tours tailored to different client interests.",
      },
    ],
  },
  "Solo Travel": {
    title: "Solo Travel",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/aboutus-service/solo%20travel.webp",
    points: [
      {
        title: "Personalized Travel Planning: ",
        desc: " Carefully designed itineraries matching individual interests, budgets, and travel preferences for a seamless journey.",
      },
      {
        title: "Safe & Reliable Support:",
        desc: "Trusted local partners, verified accommodations, and 24/7 assistance provide confidence throughout the trip.",
      },
      {
        title: "Flexible Travel Experiences:",
        desc: " Independent travelers enjoy the freedom to explore while benefiting from professional planning and local expertise.",
      },
      {
        title: "Curated Destination Insights:",
        desc: " Recommendations for attractions, dining, cultural experiences, and hidden gems help maximize every destination.",
      },
       {
        title: "Handpicked Accommodation Options:",
        desc: " Carefully selected hotels and stays offer comfort, convenience, and value throughout the journey.",
      },
    ],
  },
  "Airport Transfers ": {
    title: "Airport Transfers ",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/aboutus-service/airport%20transfer.webp",
    points: [
      {
        title: "Meet & Greet Services:",
        desc: "Professional representatives welcome travelers upon arrival and assist with smooth airport-to-hotel transfers.",
      },
      {
        title: "Wide Range of Vehicles:",
        desc: "Luxury cars, executive sedans, SUVs, and group transportation options cater to every travel requirement.",
      },
      {
        title: "Timely & Hassle-Free Operations:",
        desc: " Real-time flight monitoring and coordinated scheduling ensure punctual pickups and drop-offs.",
      },
      {
        title: "Comfortable Travel Experience:",
        desc: " Well-maintained vehicles and experienced drivers provide safe, efficient, and comfortable airport transportation.",
      },
       {
        title: "24/7 Transfer Availability:",
        desc: "Round-the-clock transportation support accommodates early arrivals, late departures, and changing flight schedules.",
      },
    ],
  },
  "Visa Services": {
    title: "Visa Services ",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/aboutus-service/visa%20service.webp",
    points: [
      {
        title: "End-to-End Visa Assistance:",
        desc: " Our team supports documentation, application guidance, and processing requirements, helping agents simplify visa arrangements for their clients.",
      },
      {
        title: "Multi-Destination Expertise:",
        desc: "Extensive experience handling visa requirements across popular destinations in the Middle East, Asia, and beyond ensures smoother travel planning.",
      },
      {
        title: "Faster Documentation Support:",
        desc: "Dedicated assistance with invitation letters, itinerary preparation, and supporting documents helps reduce delays and errors.",
      },
      {
        title: "Reliable Client Coordination:",
        desc: "Regular updates and transparent communication keep agents informed throughout the visa application process.",
      },
       {
        title: "Group Visa Management:",
        desc: "Efficient handling of group visa applications for corporate delegations, events, and leisure groups ensures a streamlined process.",
      },
    ],
  },
};

const tabs = Object.keys(servicesData);

const AboutUsSec2 = () => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const tabFromURL = queryParams.get("tab");

  const safeTab = servicesData[tabFromURL] ? tabFromURL : "MICE";

  const [activeTab, setActiveTab] = useState(safeTab);

  // ✅ update tab on URL change
  useEffect(() => {
    if (servicesData[tabFromURL]) {
      setActiveTab(tabFromURL);
    }
  }, [tabFromURL]);

  // ✅ scroll AFTER render
  useEffect(() => {
    // ✅ only scroll if tab exists in URL
    if (!tabFromURL) return;

    const el = document.getElementById("about-sec2-id");

    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 200);
    }
  }, [tabFromURL]);

  const currentData = servicesData[activeTab];
  return (
    <div id="about-sec2-id" className="services-container standard-padding">
      <h1 className=" heading mb-4">
        From Planning To Perfection - We Deliver{" "}
      </h1>

      {/* Tabs */}
      <div className="tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content */}
   <div className="services-card">
  <h3 className="mobile-heading">{currentData.title}</h3>

  <div className="services-left">
    <h3 className="desktop-heading">{currentData.title}</h3>

    {currentData.points.map((point, index) => (
      <div key={index} className="point-item">
        <span className="point-title">{point.title}</span>
        <span className="point-desc"> {point.desc}</span>
      </div>
    ))}
  </div>

  <div className="services-right">
    <img src={currentData.image} alt="services" />
  </div>
</div>
    </div>
  );
};

export default AboutUsSec2;
